// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
// @ts-ignore
import Icona from 'components/corporatiu/ui/Icona';
import styles from './calaixBotons.module.scss';
import { CalaixBotonsProps } from './CalaixBotons.types';

const CalaixBotons = (props: Readonly<CalaixBotonsProps>) => {
    const { titol, botons } = props;

    return (
        <div className={styles.botons}>
            {titol && <Titol titol={titol} tag='h2' tipus='gran' />}
            <div className={styles.botonsWrapper}>
                {botons?.map((botoItem, index) => (
                    <Enllac key={index} href={botoItem?.enllac} className={styles.botoItem} novaFinestra={true}>
                        <Icona
                            className={styles.icona}
                            icona={`${botoItem?.icona}`}
                            alt={`${botoItem?.text}`}
                            isBlanc={true}
                            path='corporatiu'
                            mida='32'
                            aria-hidden='true'
                            inline={true}
                        />

                        <div className={styles.botoText}>{botoItem?.text}</div>

                        <Icona
                            className={styles.icona}
                            icona='fletxa_dreta'
                            alt={`Enllaç a ${botoItem?.text}`}
                            isBlanc={true}
                            path='corporatiu'
                            mida='32'
                            aria-hidden='true'
                            inline={true}
                        />
                    </Enllac>
                ))}
            </div>
        </div>
    );
};

export default CalaixBotons;
